/**
 * 🧞 GenieTip — DÉPRÉCIÉ.
 *
 * Remplacé par <GenieCoach /> (monté dans le Layout) : un conseil ADAPTATIF unique
 * par page, calculé depuis les données réelles de l'utilisateur (utils/advice.js).
 * Les GenieTip étaient des tips statiques hardcodés, one-shot, non contextualisés →
 * ils feraient doublon avec le coach (« encarts collés »).
 *
 * On garde la signature (les pages continuent d'importer et d'utiliser <GenieTip …/>)
 * mais le composant ne rend plus rien. À supprimer des pages lors d'un nettoyage.
 */
export default function GenieTip() {
  return null;
}
